import React from "react"
import { Card } from "./subcomponents/Card"
import AppLink from "../../components/AppLink"
import ArrowRight from "../../components/icons/ArrowRight"
import "./index.scss"

export const ScrollableCards = ({ scrollHeader, link, cardsArray }) => {
    return (
        <div className="scrollable-cards">
            <div className="scrollable-cards-header">
                <h3 className="t-s3">{scrollHeader}</h3>
                <AppLink to={link} className="hov-get-in-touch-black">
                    learn more <ArrowRight color="#FFFFFF" />
                </AppLink>
            </div>
            <div className="scrollable-cards-list">
                {cardsArray.map((el, id) => (
                    <Card
                        key={el.header + id}
                        image={el.image}
                        header={el.header}
                        text={el.text}
                    />
                ))}
            </div>
        </div>
    )
}
